import React, { Component } from 'react';
import ForgotPasswordComp from "../../components/ForgotPassword/ForgotPasswordComp";

class ForgotPassword extends Component {
    render() {
        return (
            <div>
                <ForgotPasswordComp />
            </div>
        );
    }
}

export default ForgotPassword;